import { Grade } from "@prisma/client";

import { IS_PRODUCTION } from "@marble/core/utils/environment";

/** Grades Marble can serve (3rd grade and above). Used to compute addressable enrollment. */
export const MARBLE_SUPPORTED_GRADES: Grade[] = [
  Grade.THIRD,
  Grade.FOURTH,
  Grade.FIFTH,
  Grade.SIXTH,
  Grade.SEVENTH,
  Grade.EIGHTH,
  Grade.NINTH,
  Grade.TENTH,
  Grade.ELEVENTH,
  Grade.TWELFTH,
];

/**
 * Words that carry no identifying signal in a school name, so two names that
 * differ only by these are the same school for duplicate-detection purposes
 * ("Lincoln High School" vs "Lincoln HS").
 */
export const SCHOOL_NAME_NOISE_WORDS = new Set([
  "the",
  "of",
  "at",
  "and",
  "a",
  "school",
  "schools",
  "campus",
  "academy",
]);

/** Abbreviations that appear in school names, mapped to their expansion. */
export const SCHOOL_NAME_ABBREVIATIONS: Record<string, string> = {
  hs: "high",
  jhs: "junior high",
  ms: "middle",
  es: "elementary",
  elem: "elementary",
  sr: "senior",
  jr: "junior",
  st: "saint",
  mt: "mount",
  ft: "fort",
  int: "intermediate",
  prep: "preparatory",
};

/**
 * Similarity at or above which two school names are treated as probably the
 * same school. Tuned to catch spelling and abbreviation drift
 * ("Lincoln Hgh School") without flagging every school sharing one word.
 */
export const SIMILAR_SCHOOL_THRESHOLD = 0.82;

/** Cap on candidates returned for one name — a list for a person to read. */
export const MAX_SIMILAR_SCHOOLS = 10;

/**
 * Most district → owner assignments one batch may carry. Sized to cover a full
 * ~750-district backfill in one call with headroom, while still bounding how
 * long the all-or-nothing transaction can hold its locks.
 */
export const MAX_DISTRICT_MARBLE_ADMIN_ASSIGNMENTS = 1000;

/**
 * The Marble contact used when a school has no owner of its own: the name,
 * scheduling link and user id that school-facing copy and notes fall back to.
 */
export const DEFAULT_SCHOOL_OWNER_INFO = IS_PRODUCTION
  ? {
      firstName: "Aneesha",
      email: "aneesha@marblehealth.com",
      schedulingLink: "https://calendly.com/aneesha-marblehealth/30min",
      phoneNumber: "+17328908702",
      userId: 2530,
      avatarUrl:
        "https://production-user-avatars.s3.us-east-1.amazonaws.com/aneesha.jpg",
    }
  : {
      firstName: "Steve",
      email: "",
      schedulingLink: "A scheduling link",
      phoneNumber: "+8881119381",
      userId: 1,
      avatarUrl:
        "https://preview-user-avatars.s3.us-east-1.amazonaws.com/jake.jpg",
    };
